import { getBearerToken } from 'shared/utils/get-bearer-token-storage';

declare var window: any;

export const helpers = {

    getConfigExt: function(): any {
        return window.sks365?.config || {};
    },

    getBuildVer: function(): string {
        return this.getConfigExt().buildVer || Date.now().toString();
    },

    getCurrentCulture: function(): string {
        return this.getConfigExt().currentCulture || 'it-IT';
    },

    getModuleId: function(): string {
        return this.getConfigExt().mId || '1';
    },

    getApiUrls: function(): any {
        return this.getConfigExt().apiUrls || {};
    },
    
    getBearerToken: function(): string {
        return getBearerToken();
    },

    getUserId: function(): any {
        return this.getConfigExt().userinfo?.uid || '0';
    },

    isSurvicateFeatureEnabled: function(): boolean {
        return window.survicateFeatureEnabled || false;
    }
}